var _path, _path2, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrutal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 73 91",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m215.766 205.261c-2.315 1.839-3.667 4.639-3.667 7.596 0 5.321 4.379 9.7 9.7 9.7s9.7-4.379 9.7-9.7c0-2.957-1.352-5.757-3.667-7.596-2.318-1.839-3.673-4.641-3.673-7.6s1.355-5.761 3.673-7.6c2.315-1.839 3.666-4.639 3.666-7.595 0-5.321-4.378-9.7-9.7-9.7-5.321 0-9.699 4.379-9.699 9.7 0 2.956 1.351 5.756 3.666 7.595 2.318 1.839 3.673 4.641 3.673 7.6s-1.355 5.761-3.673 7.6z",
    fill: "#e03248",
    fillRule: "nonzero",
    transform: "translate(-212.0985 -172.765812)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m286.873 227c.362 2.435 1.638 4.643 3.566 6.174 2.318 1.839 3.673 4.641 3.673 7.6s-1.355 5.761-3.673 7.6c-2.315 1.839-3.667 4.639-3.667 7.596 0 5.321 4.379 9.7 9.7 9.7s9.7-4.379 9.7-9.7c0-2.957-1.352-5.757-3.667-7.596-2.317-1.84-3.67-4.642-3.67-7.6s1.353-5.76 3.67-7.6c2.327-1.838 3.687-4.646 3.687-7.612 0-5.321-4.378-9.7-9.7-9.7-1.228 0-2.446.234-3.587.688-1.135.448-2.344.678-3.564.678-4.788 0-8.896-3.542-9.6-8.278-.704-4.733-4.81-8.273-9.595-8.273-5.321 0-9.7 4.378-9.7 9.7 0 5.321 4.379 9.7 9.7 9.7 1.22 0 2.428-.23 3.562-.678 1.135-.448 2.344-.679 3.565-.679 4.787 0 8.894 3.544 9.595 8.279z",
    fill: "#003267",
    fillRule: "nonzero",
    transform: "translate(-234.1135 -185.473812)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.0405,
    cy: 85.697188,
    fill: "#009a9b",
    r: 4.852
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.7035,
    cy: 70.497188,
    fill: "#ee95a3",
    r: 7.278
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrutal);
export default __webpack_public_path__ + "static/media/brutal.fa7e5001.svg";
export { ForwardRef as ReactComponent };